var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('video-player');
import { breakpoints } from '@shapeable/theme';
import ReactPlayer from 'react-player';
import { ResponsiveContainer } from './responsive-container';
export var VideoPlayerSituDefaultProps = {
  controls: true
};
// -------- Styles -------->
/* This is now default styling (previously these needed to be styled everywhere a video player was used */
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #000;\n    box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    width: 100%;\n    flex: 1;\n    position: relative;\n  "], ["\n    background: #000;\n    box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    width: 100%;\n    flex: 1;\n    position: relative;\n  "])))
});
var PlayerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute !important;\n    top: 0;\n    left: 0;\n  "], ["\n    position: absolute !important;\n    top: 0;\n    left: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(ResponsiveContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Player: styled(ReactPlayer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), PlayerStyles)
};
export var VideoPlayerSitu = function (props) {
  var className = props.className,
    playerProps = __rest(props, ["className"]);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Player, __assign({
    width: "100%",
    height: "100%"
  }, playerProps)));
};
VideoPlayerSitu.defaultProps = VideoPlayerSituDefaultProps;
VideoPlayerSitu.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;